import { lazy, type ComponentType } from "react";
import type { Config, EntryMapping } from "../config/client";
import type { RenderShellOpts } from "../renderShell";

type OptionsFn = () => RenderShellOpts;

const appComponent = (p: Promise<ComponentType>) =>
  lazy<ComponentType>(async () => p.then((x) => ({ default: x })));

const optionsFns = {
  engage(): RenderShellOpts {
    const app = appComponent(
      import("./legacyEngage/App").then(({ App }) => App)
    );
    return {
      app,
    };
  },
  mm(): RenderShellOpts {
    const app = appComponent(
      import("./messagemedia/App").then(({ App }) => App)
    );
    return {
      app,
    };
  },
  cop(): RenderShellOpts {
    const app = appComponent(import("./cop/App").then((x) => x.WrappedApp));
    return {
      app,
    };
  },
  my(): RenderShellOpts {
    const app = appComponent(
      import("./my/App").then(({ WrappedApp }) => WrappedApp)
    );
    return {
      app,
    };
  },
} as const satisfies EntryMapping<OptionsFn>;

export const getRenderShellOptions: (config: Config) => RenderShellOpts = (
  config: Config
) => config.selectByEntry(optionsFns)();
